import { Button, ButtonGroup, Card, CardBody, Col, Row } from "reactstrap";
import { EventsCalendar } from "../components/events/EventsCalendar";
import NitroAdSidebar from "../../ads/NitroAdSidebar";
import Calendar from "../components/common/Calendar";
import { useContext, useEffect, useState } from "react";
import truckyService from "../../common/services/trucky-service";
import { EnterpriseContext } from "../../components/enterprise/EnterpriseContext";
import UserUpcomingEvents from "../components/events/UserUpcomingEvents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BoxDynamicAd from "../../ads/BoxDynamicAd";

export default function EventsCalendarPage({ container }) {
  const { globalContext } = useContext(EnterpriseContext);
  const [tab, setTab] = useState("public");

  useEffect(() => {
    truckyService.setDocumentTitle("Events");
  }, []);

  return (
    <div>
      <div className="page-hero">
        <span className="page-hero-icon">
          <FontAwesomeIcon icon="calendar-days" className="mx-0"></FontAwesomeIcon>
        </span>
        <div>
          <h1 className="page-hero-title">
            {container.localeManager.strings.events}
          </h1>
        </div>
      </div>
      <Row>
      <Col>
        {globalContext.member && (
          <div className="filters-toolbar mb-3">
            <ButtonGroup>
              <Button
                color={tab === "public" ? "success" : "secondary"}
                onClick={() => setTab("public")}
              >
                <FontAwesomeIcon icon="calendar-days" className="me-1" />
                {container.localeManager.strings.publicEvents || "Public Events"}
              </Button>
              <Button
                color={tab === "my" ? "success" : "secondary"}
                onClick={() => setTab("my")}
              >
                <FontAwesomeIcon icon="star" className="me-1" />
                {container.localeManager.strings.myUpcomingEvents}
              </Button>
            </ButtonGroup>
          </div>
        )}
        <div className="mt-3">
          {tab === "public" && <EventsCalendar container={container} />}
          {tab === "my" && <UserUpcomingEvents container={container} />}
        </div>
      </Col>
      <div className="ad-column-placeholder">
        {!container.dataService.data.enablePremiumFeature() && (
          <NitroAdSidebar container={container}></NitroAdSidebar>
        )}
      </div>
      </Row>
    </div>
  );
}
